<button class="btn btn-lg btn-primary btn-ladda" data-style="expand-right" (click)="onButtonClick($event)" [class.ladda]='isLoading'>{{label}}</button>

